/* eslint-disable react/prop-types */
import { Icon, Tooltip } from "@mui/material";
import colors from "assets/theme/base/colors";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import { agregarCeros } from "utils/truncate";

const estadosBorrables = ["Envio parcial"];

const getRows = (data, accion) => {
  const rows = [];
  if (data) {
    data.forEach((item) => {
      rows.push({
        numero: (
          <SoftBox display="flex" alignItems="center">
            <SoftBox pr={0.2}>
              <Icon fontSize="small">
                {!estadosBorrables.includes(item.estado) ? "receipt" : "pause"}
              </Icon>
            </SoftBox>
            <SoftTypography verticalAlign="text-top" variant="subtitle2">
              {!estadosBorrables.includes(item.estado)
                ? agregarCeros(item.codigoSucursal, 4) + "-" + item.numero
                : "EN PAUSA"}
            </SoftTypography>
          </SoftBox>
        ),
        sucursal: (
          <SoftBox>
            <SoftTypography verticalAlign="text-top" variant="subtitle2">
              {item?.sucursal ? item?.sucursal : "-"}
            </SoftTypography>
          </SoftBox>
        ),
        destino: (
          <SoftBox>
            <SoftTypography verticalAlign="text-top" variant="subtitle2">
              {item?.sucursal_destino ? item?.sucursal_destino.name : "-"}
            </SoftTypography>
          </SoftBox>
        ),
        fecha: (
          <SoftBox>
            <SoftTypography verticalAlign="text-top" variant="subtitle2">
              {item?.fecha ? dayjs(item.fecha).format("DD-MM-YYYY HH:mm") : "-"}
            </SoftTypography>
          </SoftBox>
        ),
        estado: (
          <SoftBox>
            <SoftTypography verticalAlign="text-top" variant="subtitle2">
              {item?.estado ? item?.estado : "-"}
            </SoftTypography>
          </SoftBox>
        ),
        accion: (
          <SoftBox mr={2} display="flex" flexDirection="row" justifyContent="flex-end">
            {item.estado === "Enviado" && (
              <>
                <Tooltip title="Borrar remito" placement="top">
                  <Icon
                    fontSize="large"
                    sx={{
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      accion("borrar", item);
                    }}
                  >
                    cancel
                  </Icon>
                </Tooltip>
                {item?.sucursal === "Deposito" && (
                  <Tooltip title="Cambiar sucursal destino" placement="top">
                    <Icon
                      fontSize="large"
                      sx={{
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        accion("cambiar", item);
                      }}
                    >
                      swap_calls
                    </Icon>
                  </Tooltip>
                )}
              </>
            )}
            {estadosBorrables.includes(item.estado) ? (
              <>
                <Tooltip title="Borrar" placement="top">
                  <Icon
                    fontSize="large"
                    sx={{
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      accion("borrar", item);
                    }}
                  >
                    cancel
                  </Icon>
                </Tooltip>
                <Tooltip title="Continuar" placement="top">
                  <Link
                    to={`/remito/${item.id}`}
                    style={{
                      textDecoration: "none",
                      color: "inherit",
                    }}
                  >
                    <Icon
                      fontSize="large"
                      sx={{
                        cursor: "pointer",
                        color: colors.primary.focus,
                      }}
                    >
                      play_circle_outlined
                    </Icon>
                  </Link>
                </Tooltip>
              </>
            ) : (
              <>
                <Tooltip title="Ver pdf" placement="top">
                  <Link
                    to={`/pdf/${item.id}`}
                    style={{
                      textDecoration: "none",
                    }}
                    target="_blank"
                  >
                    <Icon
                      color="error"
                      fontSize="large"
                      sx={{
                        cursor: "pointer",
                      }}
                    >
                      picture_as_pdf
                    </Icon>
                  </Link>
                </Tooltip>
                <Tooltip title="Ver remito" placement="top">
                  <Link
                    to={`/remito/${item.id}`}
                    style={{
                      textDecoration: "none",
                      color: "inherit",
                    }}
                  >
                    <Icon
                      fontSize="large"
                      sx={{
                        cursor: "pointer",
                        color: colors.primary.focus,
                      }}
                    >
                      visibility
                    </Icon>
                  </Link>
                </Tooltip>
              </>
            )}
          </SoftBox>
        ),
      });
    });
  }

  return rows;
};

const columns = [
  { name: "numero", desc: "N° Remito", align: "left" },
  { name: "sucursal", desc: "Sucursal", align: "left" },
  { name: "destino", desc: "Destino", align: "left" },
  { name: "fecha", desc: "Fecha", align: "center" },
  { name: "estado", desc: "Estado", align: "left" },
  { name: "accion", desc: " ", align: "right", width: "1%", noOrder: true },
];

export default { columns, getRows };
